// SQA / self-host environment overlay
// Copied onto src/environments/environment.ts before ng build
export const environment = {
  production: false,
  GOOGLE_KEY: 'AIzaSyCdFDePFqp1JSeUyasD-LP2bUZreCeD9e4',
  THAICOM_URL: '',
  THAICOM_USERNAME: '',
  THAICOM_PASSWORD: '',
  THAICOM_IFARM_URL: '',
  THAICOM_IFARM_AUTH_URL: '',

  // Portal APIs (dedicated host)
  API: 'https://ifarm-portal-apis.wadteam.dev/ifarm-backend-api/be/v1/',
  API_CONTROL: 'https://ifarm-portal-apis.wadteam.dev/ifarm-thing-control-api/tc/v1/',
  API_SOCKET: 'https://ifarm-portal-apis.wadteam.dev',
  SOCKET_PATH: '/ifarm-socket-api/socket.io',
  URLUPLOAD: 'https://ifarm-portal-apis.wadteam.dev/ifarm-backend-api',
  URLUPLOADMNG: 'https://ifarm-portal-apis.wadteam.dev/ifarm-data-mng-api',
  API_GRAPH: 'https://ifarm-portal-apis.wadteam.dev/ifarm-backend-api/be/v1/',

  // Gateway (Web for redirect, APIs for token)
  API_GATEWAY: 'https://ifarm-gateway-apis.wadteam.dev/',
  GATEWAY_URL: 'https://ifarm-gateway-web.wadteam.dev',

  URL_GET_DETAIL_PLOT_BY_ID: 'farms/owner/getPlotsByPlotId',
  URL_CONTROL_BY_ID: 'farms/owner/postThingcontrol',
  URL_UPDATE_SENSOR_TYPE: 'farms/owner/updateSensorsType',
  URL_GET_SENSOR_BY_THING_ID: 'farms/owner/getSensorByThingsId',
  URL_GET_THINGS_BY_ID: 'farms/owner/getThingsByPlot',
  URL_UPDATE_EMO_BY_PLOT: 'farms/owner/updatePlotemo',
  URL_GET_ALL_EMO_BY_PLOT_AND_FARM: 'farms/owner/getPlotemo',
  URL_GET_INSERT_SCHEDUAL_AND_CONDITION: 'farms/owner/insertschedules',
  URL_GET_ALL_SCHEDUAL_AND_CONDITION: 'farms/owner/getschedules',
  URL_CREATE_PLOT_BY_FARM_ID: 'farms/owner/insertPlot',
  URL_GET_WEATHER: 'farms/owner/getWeatherStation',
  URL_GET_WEATHER_FORECAST: 'farms/owner/getWeatherForecast',
  URL_UPDATE_ACTIVE_AND_INACTIVE: 'farms/owner/Activeschedule',
  URL_DELETE_SCHEDULE_AND_CONDITION: 'farms/owner/Deleteschedule',
  URL_GET_SCHEDULE_AND_CONDITION_BY_ID: 'farms/owner/getscheduleEdit',
  URL_UPDATE_SCHEDULE_AND_CONDITION_BY_ID: 'farms/owner/updateschedule',
  URL_GET_CLIENT_CONFIG: 'farms/thing/getClientConfig',
  URL_GET_ONLINE_CONFIG: 'farms/thing/getOnlineConfig',
  URL_CREATE_ONLINE_CONFIG: 'farms/thing/createOnlineConfig',
  URL_UPDATE_ONLINE_CONFIG: 'farms/thing/updateOnlineConfig',

  URL_GET_PLOT_DASHBOARD: 'farms/plot/getPlotDashboard',
  URL_PLOT_BY_PLOT_ID: 'farms/plot/getPlotByPlotId',
  URL_GET_DROPDOWN_CHILDORG_FARM: 'farms/plot/getChildorgAndFarmByOrgId',
  URL_GET_ALL_BREED_TYPE: 'farms/breed/getAllBreedType',
  URL_GET_PLANT_TYPE_BY_BREED_TYPE_ID: 'farms/plant/getPlantingTypeByBreedTypeId',
  URL_CREATE_CROP: 'farms/crop/createCrop',
  URL_CLOSE_CROP: 'farms/crop/closeCrop',
  URL_GET_CROP_POLE: 'farms/growth/getCropPoleByCropId2',
  URL_GET_FORM_GROWTH_DATA: 'farms/growth/getFormGrowthData',
  URL_GET_INFLORESCENCE: 'farms/growth/getInflorescence',
  URL_GET_FORM_GROWTH_INFLORESCENCE_DATA: 'farms/growth/getFormGrowthDataInflorescence',
  URL_MANAGE_CROP_GROWTH_DATA: 'farms/growth/manageCropGrowthData',
  URL_GET_GROWTH_DATA_BY_ID: 'farms/growth/getById',
  URL_GET_GROWTH_FOR_DATATABLE: 'farms/growth/getByCropId',
  URL_EXPORT_GROWTH_DATA: 'farms/growth/exportCropGrowthData',
  URL_DELETE_GROWTH: 'farms/growth/deleteById',
  URL_GET_USER_DATA: 'users/platform/getPlatformUserByToken',
  URL_CREATE_USER: 'users/platform/createUser',
  URL_GET_FARM_SELECT: 'users/platform/getFarmsByOrgId',
  URL_USER_BY_USERNAME: 'users/platform/getUserByUsername',
  URL_UPDATE_FARM_AUTHORIZE: 'users/platform/updateFarmAuthorize',
  URL_GET_PLOT_MENU: 'farms/crop/getPlotforMenu',
  URL_DELETE_USER: 'users/platform/deleteUser',

  URL_GET_EXPERIMENT: 'farms/experiment/getByCropId',
  URL_GET_AVAILABLE_POLE: 'farms/experiment/getAvailablePoles',
  URL_ADD_EXPERIMENT: 'farms/experiment/addCropExperiment',
  URL_GET_EXPERIMENT_DATA: 'farms/experiment/getByCropExperimentId',
  URL_EDIT_EXPERIMENT: 'farms/experiment/editCropExperiment',

  URL_GATEWAY_REFRESH_TOKEN: 'auth/refreshToken',
  URL_PLATFORM_REFRESH_TOKEN: 'users/auth/platformrefreshToken',
  URL_GET_PLATFORM_INFO: 'auth/getPlatformInfo',

  URL_GET_EVENT_BY_CROP_ID: 'farms/event/getByCropId',
  URL_GET_EVENT_ACTIVITY_TYPE: 'farms/util/getOrgParam',
  URL_GET_EVENT_WORKING_TYPE: 'farms/util/getOrgParam',
  URL_GET_EVENT_RESPONSIBLE_PERSON: 'farms/util/getResponsiblePerson',
  URL_GET_EVENT_STATUS: 'farms/util/getOrgParam',
  URL_GET_EVENT_DISEASE: 'farms/util/getOrgParam',
  URL_GET_EVENT_AVAILABLE_POLE: 'farms/event/getAvailablePoles',
  URL_GET_EVENT_AVAILABLE_VALVES: 'farms/event/getAvailableValves',
  URL_ADD_EVENT: 'farms/event/addEvent',
  URL_GET_EVENT_BY_ID: 'farms/event/getById',
  URL_DELETE_EVENT_BY_ID: 'farms/event/deleteEvent',
  URL_EDIT_EVENT: 'farms/event/editEvent',

  URL_GET_YIELD_FOR_DATATABLE: 'farms/yield/getRoundByCropId',
  URL_ADD_YIELD_ROUND: 'farms/yield/addCropYieldRound',
  URL_EDIT_YIELD_ROUND: 'farms/yield/editCropYieldRound',
  URL_GET_ROUND_DATA: 'farms/yield/getRoundById',
  URL_GET_CROP_POLE_YIELD: 'farms/yield/getCropPoleByCropId',
  URL_GET_FORM_YIELD_DATA: 'farms/yield/getFormYieldData',
  URL_MANAGE_CROP_YIELD_DATA: 'farms/yield/manageCropYieldData',
  URL_GET_YIELD_DATA_FOR_DATATABLE: 'farms/yield/getByCropId',
  URL_GET_YIELD_DATA_BY_ID: 'farms/yield/getById',
  URL_DELETE_YIELD: 'farms/yield/deleteById',
  URL_EXPORT_YIELD_ROUND: 'farms/yield/exportCropYieldRound',
  URL_EXPORT_YIELD_DATA: 'farms/yield/exportCropYieldData',

  URL_GET_ORG_PARAM: 'farms/util/getOrgParam',

  URL_GET_USER_BY_ID: 'users/platform/getUserbyUserId',
  URL_UPDATE_USER: 'users/platform/updateUser',
  URL_CHECK_ROLE: 'users/platform/checkPlatformRole',

  URL_GET_PACKAGE: 'packages',
  URL_GET_SENSOR_DATA: 'sensorsData',
  URL_GET_REPORT_HISTORY: 'reportHistories',
  URL_GET_REPORT_FLOWER: 'farms/report/flower',
  URL_GET_REPORT_FLOWER_PLOT: 'farms/report/flower/plot',
  URL_GET_REPORT_FLOWER_ZONE: 'farms/report/flower/zone',
  URL_GET_REPORT_POD: 'farms/report/pod',
  URL_GET_REPORT_POD_ZONE: 'farms/report/pod/zone',
  URL_GET_REPORT_POD_PLOT: 'farms/report/pod/plot',
  URL_GET_LIST_PLOT: 'farms/plot/list',
  URL_GET_LIST_POLE: 'farms/pole/find',
  URL_GET_LIST_ZONE: 'farms/zone/list',

  URL_MAIN_YIELD_TEMPLATES: 'breedtypes/mainyieldtemplates',
  URL_YIELD_TEMPLATES: 'yieldtemplates',
  URL_GET_CROPPOLES: 'croppoles',
  URL_YIELD_DATA: 'yielddata',

  URL_GET_FARM_BY_NAME: 'farms/farm/findFarmByName',
  URL_CREATE_FARM: 'farms/farm/createNewFarm',
  URL_UPDATE_FARM: 'farms/farm/updateFarm',
  URL_DELETE_FARM: 'farms/farm/deleteFarm',
  URL_CREATE_NEW_ZONE: 'farms/zone/createNewZone',
  URL_CREATE_NEW_PLOT: 'farms/plot/createNewPlot',
  URL_UPDATE_NEW_PLOT: 'farms/plot/updateNewPlot',
  URL_DELETE_PLOT: 'farms/plot/deletePlot',
  URL_GET_PLOT_BY_NAME: 'farms/plot/findplotByName',
  URL_GET_ZONE: 'farms/zone/getZone',
  URL_DELETE_ZONE: 'farms/zone/deleteZone',
  URL_UPDATE_ZONE: 'farms/zone/updateZone',
  URL_CREATE_REALTIME_CAMERA: 'farms/camera/createRealtimeCamera',
  URL_UPDATE_REALTIME_CAMERA: 'farms/camera/updateRealtimeCamera',

  URL_GET_BREED_TYPE_BY_FARM: 'farms/breed/getBreedTypeByFarm',
  URL_GET_PLOT_LIST: 'farms/plot/list/crop',
  URL_GET_POLE_LIST: 'farms/pole/list/cropPole',
  URL_GET_REPORT_YIELD_BREED: 'farms/yield/report/breed',
  URL_GET_REPORT_YIELD_FARM: 'farms/yield/report/farm',
  URL_GET_REPORT_YIELD_LIST: 'farms/yield/report/list',
  URL_GET_REPORT_YIELD_DETAIL: 'farms/yield/report/detail',

  URL_GET_THING_MGL: 'farms/thing/getThingMGL',
  URL_GET_SENSOR_TYPE: 'farms/thing/getSensorType',
  URL_GET_THING_BY_THING_ID: 'farms/thing/getThingByThingId',
  URL_CREATE_THING: 'farms/thing/createThing',
  URL_UPDATE_THING: 'farms/thing/updateThing',
  URL_CREATE_SENSOR: 'farms/thing/createSensor',
  URL_UPDATE_SENSOR: 'farms/thing/updateSensor',
  URL_DELETE_THING: 'farms/thing/deleteThing',

  URL_GET_MEDIA: 'medias/getMedia',
  URL_GET_CAMERA: 'medias/getCameraList',

  URL_GET_THAICOM_KEY: 'farms/farm/getThaicomKey',
};
